<mat-drawer-container class="flex-auto h-full w-full" (backdropClick)="closeRightPanel()">
  <mat-drawer
    class="z-99 w-3/4 md:w-2/4 xl:w-1/4"
    [autoFocus]="false"
    [mode]="rightPanelMode"
    [opened]="rightPanelOpened"
    position="end"
    #rightPanel
    *ngIf="showRightPanel">
    <!-- Header -->
    <div class="flex items-center justify-between m-8 mr-6 sm:my-10">
      <h3 class="text-xl">{{ rightPanelComponent?.title }}</h3>
      <!-- Close button -->
      <button mat-icon-button (click)="closeRightPanel()">
        <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
    <div class="flex flex-col min-w-1/4 m-8 mr-10">
      <ng-content select="vtab-right-panel"></ng-content>
    </div>
  </mat-drawer>
  <!-- Drawer -->
  <mat-drawer class="sm:w-96 dark:bg-gray-900" [autoFocus]="false" [mode]="drawerMode" [opened]="drawerOpened"
              [disableClose]="drawerMode === 'side'" #drawer>
    <!-- Header -->
    <div class="flex items-center justify-between m-8">
      <!-- Title -->
      <div class="text-3xl font-extrabold tracking-tight leading-none">
        <ng-container *ngIf="showBackButton">
          <a
            class="inline-flex items-center -ml-1.5 text-secondary font-medium text-sm cursor-pointer"
            *ngIf="appTitleLink"
            [routerLink]="appTitleLink">
            <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
            <span class="ml-1">Back</span>
          </a>
          <a
            class="inline-flex items-center -ml-1.5 text-secondary font-medium text-sm cursor-pointer"
            *ngIf="!appTitleLink"
            (click)="triggerBackClicked($event)">
            <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
            <span class="ml-1">Back</span>
          </a>
          <br />
        </ng-container>
        <ng-content select="vtab-panel-title"></ng-content>
      </div>

      <!-- Close button -->
      <div class="lg:hidden">
        <button mat-icon-button (click)="drawer.close()">
          <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
      </div>
    </div>
    <!-- Panel links -->
    <div class="flex flex-col divide-y border-t border-b">
      <ng-container *ngFor="let tab of _vtabs; trackBy: trackByFn">
        <div
          class="flex px-8 py-5 cursor-pointer"
          *ngIf="tab.visible"
          [ngClass]="{
            'hover:bg-gray-100 dark:hover:bg-hover': !selectedTab || selectedTab !== tab,
            'bg-primary-50 dark:bg-hover': selectedTab && selectedTab === tab,
          }"
          (click)="goToTab(tab)">
          <mat-icon
            *ngIf="tab.icon"
            [ngClass]="{
              'text-hint': !selectedTab || selectedTab !== tab,
              'text-primary dark:text-primary-500': selectedTab && selectedTab === tab,
            }"
            [svgIcon]="tab.icon"></mat-icon>
          <div class="ml-3">
            <div
              class="font-medium leading-6"
              [ngClass]="{
                'text-primary dark:text-primary-500': selectedTab && selectedTab === tab,
              }">
              {{ tab.pageTitle }}
            </div>
            <div class="mt-0.5 text-secondary">
              {{ tab.description }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="settingButtonConfig">
      <div class="mt-auto border-t">
        <setting-button [config]="settingButtonConfig"></setting-button>
      </div>
    </ng-container>
  </mat-drawer>

  <!-- Drawer content -->
  <mat-drawer-content class="flex bg-white dark:bg-default flex-col flex-grow">
    <!-- Main -->
    <div id="vtab-drawer-container" class="flex flex-col flex-grow overflow-y-auto relative" #topAnchor>
      <!-- Panel header -->
      <div
        class="flex items-start px-6 mr-10 [@media(min-width:496px)]:mr-0 mt-6 mb-4 md:px-8 lg:pl-12 lg:pr-8 md:mt-8 flex-row">
        <div class="flex items-center w-full">
          <!-- Drawer toggle -->
          <button class="lg:hidden -ml-2" mat-icon-button (click)="drawer.toggle()">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
          </button>

          <!-- Panel title -->
          <div class="ml-2 lg:-ml-4 flex w-11/12 flex-col tracking-tight leading-none">
            <span class="mb-2 box-border pr-4 truncate">
            <a
              class="inline-flex items-center -ml-1 text-secondary font-medium text-sm cursor-pointer"
              *ngIf="appTitle !== null && appTitleLink"
              [routerLink]="appTitleLink">
                <span class="ml-1">{{ appTitle }}</span>
                <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
              </a>

              <a
                class="inline-flex items-center -ml-1 text-secondary font-medium text-sm cursor-pointer"
                *ngIf="appTitle !== null && !appTitleLink"
                (click)="triggerBackClicked($event)">
                <span class="ml-1">{{ appTitle }}</span>
                <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
              </a>

              <!-- Handle pageItemTitles array (breadcrumbs) -->
              <ng-container *ngIf="selectedTab && hasBreadcrumbs(selectedTab)">
                <ng-container *ngFor="let breadcrumb of getBreadcrumbs(selectedTab); let last = last">
                  <!-- For external links -->
                  <a
                    *ngIf="breadcrumb.link && !breadcrumb.routeLink"
                    class="inline-flex items-center -ml-1 text-secondary font-medium text-sm cursor-pointer"
                    [href]="breadcrumb.link"
                    [target]="breadcrumb.openInNewWindow ? '_blank' : '_self'">
                    {{ breadcrumb.title }}

                    <mat-icon
                      *ngIf="!last"
                      class="icon-size-5 text-secondary"
                      [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                  </a>

                  <!-- For router links -->
                  <a
                    *ngIf="breadcrumb.routeLink && !breadcrumb.link"
                    class="inline-flex items-center -ml-1 text-secondary font-medium text-sm cursor-pointer"
                    [routerLink]="breadcrumb.routeLink"
                    [target]="breadcrumb.openInNewWindow ? '_blank' : '_self'">
                    {{ breadcrumb.title }}

                    <mat-icon
                      *ngIf="!last"
                      class="icon-size-5 text-secondary"
                      [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                  </a>

                  <!-- For plain text -->
                  <span
                    *ngIf="!breadcrumb.link && !breadcrumb.routeLink"
                    class="inline-flex items-center -ml-1 text-secondary font-medium text-sm">
                    {{ breadcrumb.title }}

                    <mat-icon
                      *ngIf="!last"
                      class="icon-size-5 text-secondary"
                      [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                  </span>
                </ng-container>
              </ng-container>

              <!-- Fallback to single pageItemTitle if pageItemTitles is not available -->
              <span
                *ngIf="
                  selectedTab &&
                  !getTabInfo(selectedTab).pageItemTitles?.length &&
                  getTabInfo(selectedTab).pageItemTitle
                "
                class="text-secondary font-medium text-sm">
                {{ getTabInfo(selectedTab).pageItemTitle }}
              </span>
            </span>
            <span class="text-3xl font-bold" *ngIf="selectedTab">{{ getTabInfo(selectedTab).pageTitle }}</span>
          </div>

          <!-- todo: support buttons here. -->
          <!-- <div>
            <button mat-icon-button (click)="drawer.close()">
              <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
          </div> -->
        </div>

        <div
          class="flex ml-2 flex-row w-auto space-x-4 items-end md:justify-end [&>vtab-action-top]:w-full md:[&>vtab-action-top]:w-auto">
          <ng-content select="vtab-action-top"></ng-content>
        </div>
      </div>

      <!-- Panels -->
      <!-- px-6 md:p-8 -->
      <div [ngClass]="{ 'px-6 md:p-8': includePadding }" class="flex flex-grow flex-col flex-1 min-h-0">
        <ng-content select="vtab"></ng-content>
      </div>
    </div>
    <ng-container *ngIf="showActionBar">
      <div
        class="relative md:sticky bottom-0 w-full left-0 flex flex-row border-t bg-slate-200 dark:bg-slate-700 border-slate-200 p-4 control-panel z-50">
        <ng-content select="vtab-action-bar"></ng-content>
      </div>
    </ng-container>
  </mat-drawer-content>
</mat-drawer-container>
